export default __webpack_public_path__ + "static/media/mobileApp2.b6b0088d.png";